module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/sparkles-top-shooting.f9a27df8.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/sparkles-top-shooting.png
// module id = 2850
// module chunks = 11